import { Components, Theme } from "@mui/material";

export const button: Components<Theme>["MuiButton"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 56,
      borderRadius: Number(theme.shape.borderRadius) * 8,
      width: "100%",
      fontSize: 20,
      fontWeight: 600,
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
        minHeight: 48,
      },
    }),
  },
  variants: [
    {
      props: { variant: "contained", color: "secondary" },
      style: ({ theme }) => ({
        color: theme.palette.common.white,
      }),
    },
  ],
};
